import { TasksTable } from 'components/common/TasksTable';
import { GMPMessageColumn } from 'pages/GMP/GMPList/components/GMPMessageColumns';
import { routes } from 'routes/routesConst';

import useTaskTable from './useGMPMessageTable';

export function GMPMessageTable() {
  const { taskListData, tasksSortOrder, tasksOnSort, gmpMessageLoading, setPhase } = useTaskTable();
  return (
    <TasksTable
      taskData={[...(taskListData || [])]}
      column={GMPMessageColumn()}
      title="GMP Messages"
      classNames={{
        tableBase: 'md:max-h-[530px] overflow-auto',
        bodyRow: '!py-4 items-start !h-auto grid grid-cols-2',
        row: 'md:grid-cols-[minmax(130px,15%)_minmax(180px,15%)_minmax(170px,25%)_minmax(170px,25%)_minmax(190px,10%)_minmax(114px,5%)_minmax(114px,5%)] last:border-none',
        bodyWrapper:
          'flex flex-col min-h-auto h-auto min-h-[200px] max-h-[360px] overflow-auto border-b border-lightGray',
      }}
      sortOrder={tasksSortOrder}
      onSort={tasksOnSort}
      isLoading={gmpMessageLoading}
      onPhaseChange={setPhase}
      alwaysShowHeader
      link={`${routes.gmp}?tab=gmpmessages`}
    />
  );
}
